import { useMemo } from 'react';
import { ContentPageAPI } from 'src/shared/services/api/contentPageAPI';
import { useQuery } from '@tanstack/react-query';

type UseContentStatsArgs = {
  contentPageId?: number;
  rangeDays: number;
  enabled?: boolean;
};

export const useContentStats = ({
  contentPageId,
  rangeDays,
  enabled = true,
}: UseContentStatsArgs) => {
  const queryKey = useMemo(
    () => ['contentStats', contentPageId, rangeDays],
    [contentPageId, rangeDays],
  );

  const { data, isLoading, refetch } = useQuery({
    queryKey,
    queryFn: async () => {
      const contentApi = new ContentPageAPI();
      return contentApi.GetStatsV2(contentPageId as number, rangeDays);
    },
    enabled: enabled && !!contentPageId,
  });

  return {
    allViews: data?.allViews ?? null,
    uniqueViews: data?.uniqueViews ?? null,
    loading: isLoading,
    refetch,
  };
};
